import React, { useRef } from 'react';
import CasesSlider from './CasesSlider';

const Cases = () => {
  return (
    <div className="bg-white">
      <div className="container py-48  ">
        <div className="flex gap-[48px] flex-col ">
          <h2 className="flex justify-center items-center font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black">
            Our SEO Cases
          </h2>
          <CasesSlider />
        </div>
      </div>
    </div>
  );
};

export default Cases;
